// extracted by mini-css-extract-plugin
export default {"banner_add":"Home_banner_add__WRoWg","card_list_title":"Home_card_list_title__dez0S","Flickity":"Home_Flickity__iiAQG"};